<template>
  <div class="knowledge">
    <nav-header page="index" backgroundColor="transparent"></nav-header>
    <div class="banner">
      <img
        class="welcome"
        style="width: 192px; height: 25px"
        src="../../assets/img/knowledge-base/welcome.png"
      />
      <div class="text">为您解决万商服相关问题</div>
      <div class="search" @click="onSearch">
        <img src="../../assets/img/knowledge-base/search.png" />
        <span>请输入您问题的关键字</span>
      </div>
    </div>
    <div class="content">
      <div class="question">
        <div class="nav-bar">
          <van-tabs v-model="tabActive" sticky @change="tabChangeHandler">
            <van-tab
              v-for="item in tabs"
              :key="item.categoryId"
              :title="item.categoryName"
            ></van-tab>
          </van-tabs>
        </div>
        <div class="list" :key="key">
          <van-list
            v-if="!isEmpty"
            class="orders"
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            :offset="50"
            :immediate-check="false"
          >
            <van-cell
              v-for="item in list"
              :title="item.questionName"
              is-link
              :key="item.questionId"
              :to="'/knowledge/detail?id=' + item.questionId"
            />
          </van-list>
          <van-empty
            v-else
            :image="require('../../assets/img/knowledge-base/img_empty.png')"
            description="暂无数据"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetTabList, apiGetQuestionList } from '@/api/knowledgeBase.js';
import NavHeader from './navHeader.vue';
import { Empty } from 'vant';
export default {
  components: {
    NavHeader,
    VanEmpty: Empty,
  },
  data() {
    return {
      tabActive: 0,
      loading: false,
      isEmpty: false,
      finished: false,
      tabs: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      list: [],
      key: 1,
    };
  },
  methods: {
    async getTabs() {
      this.tabs = await apiGetTabList();
    },
    getList() {
      let data = {
        categoryId: this.tabs[this.tabActive].categoryId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        questionStatus: 1,
      };
      console.log((this.pageNum = 1));

      apiGetQuestionList(data).then((res) => {
        this.list = this.list.concat(res.items);
        this.isEmpty = !this.list.length;
        this.total = res.totalCount;
        this.loading = false;
        this.pageNum++;
        if (this.list.length >= this.total) {
          this.finished = true;
        }
      });
    },
    onSearch() {
      this.$router.push({
        path: '/knowledge/search',
      });
    },
    tabChangeHandler(value) {
      this.key = this.key + 1;
      this.tabActive = value;
      this.pageNum = 1;
      this.list = [];
      this.finished = false;
      this.loading = true;
      this.isEmpty = false;
      this.onLoad();
    },
    onLoad() {
      this.getList();
    },
  },
  async mounted() {
    // url - mp.sit.betonds.com/h5-app-sh/#/auth/knowledgeIndex?token=
    // this.$store.commit('account/ACCOUNT_TOKEN', 'ODI5NzM3MTE5MDA5MjgwMDAw');
    // this.$store.commit('account/ACCOUNT_USER_ID', '1640218397');
    await this.getTabs();
    this.getList();
  },
};
</script>


<style lang="less" scoped>
.knowledge {
  display: flex;
  flex-direction: column;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 1;
  text-align: left;
  background-color: #FFF0E2;
  background-image: url('../../assets/img/knowledge-base/img_bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  border-bottom: 1px solid #FFF0E2;
  padding-bottom: env(safe-area-inset-bottom);
  .banner {
    padding: 12px;
    .welcome {
      width: 192px;
      height: 29px;
    }
    .text {
      font-size: 12px;
      font-weight: 400;
      color: #111111;
      margin-top: 8px;
    }
    .search {
      height: 32px;
      background: #ffffff;
      border-radius: 20px;
      display: flex;
      align-items: center;
      margin-top: 20px;
      img {
        height: 16px;
        width: 16px;
        margin-left: 16px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin-left: 2px;
      }
    }
  }
  .content {
    flex: 1;
    flex-shrink: 0;
    padding: 0 12px;
    overflow: hidden;
    padding-bottom: 40px;
    .question {
      background-color: #ffffff;
      border-radius: 8px;
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      z-index: 999;
      position: relative;

      .nav-bar {
        padding-right: 20px;
        /deep/.van-tabs__nav {
          box-shadow: -6px 0px 10px 0px #efefef inset;
          padding-left: 0;
          -webkit-transform: rotate(0deg);
          border-radius: 8px 0px 0px 0px;
        }
        /deep/.van-tabs__line {
          background: linear-gradient(
            270deg,
            rgba(255, 131, 102, 0) 0%,
            #FF6F00 100%
          );
          border-radius: 4px;
          bottom: 21px;
        }
        /deep/.van-tab--active {
          color: #111111;
          font-weight: 600;
        }
        
      }
      .list {
        flex: 1;
        overflow: scroll;
        border-radius: 8px;
        /deep/.van-list {
          -webkit-transform: rotate(0deg);
          border-radius: 8px;
          overflow: hidden;
        }
        /deep/.van-cell {
          padding-top: 13px;
          padding-bottom: 13px;
          color: #111111;
        }
        /deep/.van-cell__right-icon {
          color: #bebebe;
          font-size: 15px;
        }
      }
    }
  }
  .bottom {
    height: 40px;
    flex-shrink: 0;
    background-color: #ffe5e5;
  }
}
</style>
